export const isEmpty = obj => {
  return obj && Object.keys(obj).length === 0;
};

export const flattened = arr => {
  return arr.reduce((acc, currentValue) => acc.concat(currentValue), [])
};
